import type { BaseEntity } from 'core/base';
import type { PasteInfo } from '../types';

/**
 * Returns tuple types that include every string in union
 * TupleUnion<keyof { bar: string; leet: number }>;
 * ["bar", "leet"] | ["leet", "bar"];
 */
type TupleUnion<U extends string, R extends string[] = []> = {
  [S in U]: Exclude<U, S> extends never ? [...R, S] : TupleUnion<Exclude<U, S>, [...R, S]>;
}[U] &
  string[];

const KEYS: TupleUnion<keyof PasteInfo> = ['documents', 'rootId', 'isExport', 'isCopy'];

export const parsePasteInfo = <TEntity extends BaseEntity = BaseEntity>(
  str: string,
): PasteInfo<TEntity> | null => {
  try {
    const info = JSON.parse(str);

    if (KEYS.every(key => Object.hasOwn(info, key))) {
      return info as PasteInfo<TEntity>;
    }

    return null;
  } catch {
    return null;
  }
};
